import {
  MarkdownBody,
  StylesMarkdown,
  Heading1,
  Heading2,
  Heading3,
  Paragraph,
  MarkdownStyleContainer,
  anchorStyles,
} from './Markdown.style';
import MarkdownContent from './MarkdownContent';

export {
  MarkdownBody,
  MarkdownContent,
  StylesMarkdown,
  Heading1,
  Heading2,
  Heading3,
  Paragraph,
  MarkdownStyleContainer,
  anchorStyles,
};
